import * as constants from './constants';

const initialState = {
  vacancyModalIsOpen: false,
  sidebarIsOpen: false,
  formsModalIsOpen: false,
  formsModalTab: '',
  clientWidth: 1200,
  animationIsEnded: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.TOGGLE_VACANCY_MODAL:
      return {
        ...state,
        vacancyModalIsOpen: action.flag
      }
    case constants.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarIsOpen: action.flag
      }
    case constants.TOGGLE_FORMS_MODAL:
      return {
        ...state,
        formsModalIsOpen: action.flag,
        formsModalTab: action.tab
      }
    case constants.SET_CLIENT_WIDTH:
      return {
        ...state,
        clientWidth: action.clientWidth
      }
    case constants.END_ANIMATION:
      return {
        ...state,
        animationIsEnded: true
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducer.js